var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex flex-row align-items-center justify-content-between"},[_c('h1',[_vm._v(_vm._s(_vm.$t('workflows')))]),_c('router-link',{staticClass:"btn btn-primary mb-3",attrs:{"to":"/settings/workflows/edit"}},[_vm._v(" "+_vm._s(_vm.$t('new'))+" ")])],1),_c('div',{staticClass:"col-12"},[_c('Table',{attrs:{"loading":_vm.loading,"submitting":_vm.submitting,"cols":[
					{ key: 'title', heading: _vm.$t('name'), size: 4 },
					{ key: 'note', heading: _vm.$t('description'), size: 6 },
                    {
                    	key: 'status',
                    	heading: _vm.$t('status'),
                    	size: 2,
                    	sortable: false ,
						cb: (el) => {
							if(el.status == 1) return _vm.$t('active');
							if(el.status == 2) return _vm.$t('disabled');
							if(el.status == 3) return _vm.$t('deleted');
							return ''
						}
                    }
				],"data":_vm.workflows,"breakpoint":"md","filters":{
                    ..._vm.filters,
                    page: _vm.filters.page,
                    page_size: _vm.filters.page_size,
                },"searchable":true,"scrollPaginate":true,"allowRightClick":false},on:{"selectItem":workflow => _vm.$router.push(`/settings/workflows/edit/${workflow.id}`),"refresh":_vm.refresh,"toPage":_vm.toPage},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"list-group-item align-items-center"},[_c('div',{staticClass:"form-inline"},[_c('CheckboxInput',{staticClass:"ml-4 align-items-center",attrs:{"value":_vm.filters.just_active,"label":_vm.$t('show-active-workflows-only')},on:{"input":value => _vm.refresh({ just_active: value, page: 1 })}})],1)])]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }